var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("normalDialog", {
    attrs: {
      title: _vm.$t("label_essweb_RosterRecordForm_form_backToTitle"),
      width: "600",
      dialog: _vm.show,
    },
    on: { close: _vm.closeDialog },
    scopedSlots: _vm._u([
      {
        key: "content",
        fn: function () {
          return [
            _c(
              "v-form",
              { ref: "form", attrs: { "lazy-validation": "" } },
              [
                _c(
                  "v-row",
                  [
                    _c(
                      "v-col",
                      {
                        attrs: {
                          xs: "12",
                          sm: "12",
                          md: "12",
                          lg: "12",
                          cols: "12",
                        },
                      },
                      [
                        _c(
                          "v-sheet",
                          {
                            staticClass: "d-flex flex-row align-center",
                            on: {
                              click: function ($event) {
                                _vm.previewNode == 0
                                  ? ((_vm.previewNode = 1),
                                    (_vm.previewMan = 0))
                                  : null
                              },
                            },
                          },
                          [
                            _c("v-rating", {
                              staticClass: "mx-2",
                              attrs: {
                                size: "25",
                                readonly: "",
                                "background-color": "primary ",
                                color: "primary",
                                "empty-icon": "radio_button_unchecked",
                                "full-icon": "radio_button_checked",
                                length: 1,
                                dense: "",
                              },
                              model: {
                                value: _vm.previewNode,
                                callback: function ($$v) {
                                  _vm.previewNode = $$v
                                },
                                expression: "previewNode",
                              },
                            }),
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t(
                                    "label_essweb_approvalApplication_form_back_preNodeLabel"
                                  )
                                ) +
                                " "
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        attrs: {
                          xs: "12",
                          sm: "12",
                          md: "12",
                          lg: "12",
                          cols: "12",
                        },
                      },
                      [
                        _c(
                          "v-sheet",
                          {
                            staticClass: "d-flex flex-row align-center",
                            on: {
                              click: function ($event) {
                                _vm.previewMan == 0
                                  ? ((_vm.previewMan = 1),
                                    (_vm.previewNode = 0))
                                  : null
                              },
                            },
                          },
                          [
                            _c("v-rating", {
                              staticClass: "mx-2",
                              attrs: {
                                size: "25",
                                readonly: "",
                                "background-color": "primary ",
                                color: "primary",
                                length: 1,
                                dense: "",
                                "empty-icon": "radio_button_unchecked",
                                "full-icon": "radio_button_checked",
                              },
                              model: {
                                value: _vm.previewMan,
                                callback: function ($$v) {
                                  _vm.previewMan = $$v
                                },
                                expression: "previewMan",
                              },
                            }),
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t(
                                    "label_essweb_approvalApplication_form_back_preManLabel"
                                  )
                                ) +
                                " "
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "actions",
        fn: function () {
          return [
            _c("CardActions", {
              attrs: { okBtn: "" },
              on: { cancel: _vm.closeDialog, ok: _vm.toSubmit },
            }),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }